import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api/api";
import LeftSidebar from "../components/sidebar";
import Header from "../components/Header";
import ProfileMenu from "../components/ProfileMenu";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: ""
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.current_password || !formData.new_password || !formData.confirm_password) {
      toast.error("Please fill in both fields");
      return;
    }
    if (formData.new_password !== formData.confirm_password) {
      toast.error("New password and repeat password do not match");
      return;
    }

    try {
      setLoading(true);
      
      await api.post("/auth/change-password", formData);
      
      toast.success("Password changed successfully!");
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="dashboard-screen">
      <div className="container-fluid">
        <div className="row gx-5">
          <div className="col-lg-3 left-sidebar-main">
           <LeftSidebar />
          </div>
          <div className="col-lg-9">
             <Header />
            <div className="row contact-section" >
              <div className="col-lg-4 profile-sidebar-menu">
                <div className="sec1">
                  <ProfileMenu />
                </div>
              </div>
              <div className="col-lg-8">
                <div className="sec2">
                  <div className="form-section">
                    <div className="row mb-3">
                      <div className="col-sm-12">
                        <h3>Change Your Password</h3>
                        <p>Keep your account protected with a new password</p>
                      </div>
                    </div>
                        <form onSubmit={handleSubmit}>
                          <div className="col-md-12 mb-3">
                            <label className="form-label">Current Password</label>
                            <div className="iconInput">
                              <input
                                type="password"
                                className="form-control"
                                value={formData.current_password}
                                onChange={(e) => setFormData({...formData, current_password: e.target.value})}
                                required
                              />
                              <img src="/icons/lock.svg" alt="password"/>
                            </div>
                          </div>
                          
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">New Password</label>
                              <div className="iconInput">
                                <input
                                  type="password"
                                  className="form-control"
                                  value={formData.new_password}
                                  onChange={(e) => setFormData({...formData, new_password: e.target.value})}
                                  required
                                />
                                <img src="/icons/lock.svg" alt="password"/>
                              </div>  
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Repeat Password</label>
                              <div className="iconInput">
                                <input
                                  type="password"
                                  className="form-control"
                                  value={formData.confirm_password}
                                  onChange={(e) => setFormData({...formData, confirm_password: e.target.value})}
                                  required
                                />
                                <img src="/icons/lock.svg" alt="password"/>
                              </div>  
                            </div>
                          </div>
                          
                          <div className="mt-5 cta-section align-items-center">
                            <button
                              type="button"
                              className="btn5"
                              onClick={() => navigate(-1)}
                            >
                              Back
                            </button>
                            <button 
                              type="submit" 
                              className="btn5" 
                              disabled={loading}
                            >
                              {loading ? 'Changing...' : 'Change Password'}
                            </button>
                          </div>
                        </form>
                    
                    
                  </div>              
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
